export const SITE_SECTION = "realtors";
export const UNKNOWN = "unknown";
export const ENABLE_TRACKING = {
  YES: "y",
  NO: "n",
};
export const SEARCH_TYPE = {
  CITY_STATE: "city-state",
  ZIP: "zip",
  NAME: "name",
};
export const PAGE_TRACKING = {
  SRP_LIST: {
    PAGE_TYPE: "srp_list",
    PAGE_NAME: "realtors:srp_list",
  },
  SRP_MAP: {
    PAGE_TYPE: "srp_map",
    PAGE_NAME: "realtors:srp_map",
  },
  LEAD_MODAL: {
    MODAL_TRIGGER: "realtors:srp_list:agent_list_card:contact_email",
    MODAL_NAME: "realtors:lead_modal",
  },
  MAP_LEAD_MODAL: {
    MODAL_TRIGGER: "realtors:srp_map:agent_map_card:contact_email",
    MODAL_NAME: "realtors:lead_modal",
  },
  CDP_MODAL: {
    CONTACT_MODAL_TRIGGER: "realtors:office_details:cover:contact_info",
    CONTACT_MODAL_NAME: "realtors:office_contact_info",
    SHARE_MODAL_NAME: "realtors:office_share_page",
    SHARE_MODAL_TRIGGER: "realtors:office_details:contact_details:share",
  },
  CDP_LIST: {
    PAGE_TYPE: "office_details",
    PAGE_NAME: "realtors:office_details",
  },
  TDP_PAGE: {
    PAGE_TYPE: "team_details",
    PAGE_NAME: "realtors:team_details",
  },
  TDP_MODAL: {
    CONTACT_MODAL_TRIGGER: "realtors:team_details:cover:contact_info",
    CONTACT_MODAL_NAME: "realtors:team_contact_info",
    SHARE_MODAL_NAME: "realtors:team_share_page",
    SHARE_MODAL_TRIGGER: "realtors:team_details:contact_details:share",
  },
  ADP_PAGE: {
    PAGE_TYPE: "agent_details",
    PAGE_NAME: "realtors:agent_details",
    PAGE_NAME_NAR: "realtors:agent_details_nar",
    PAGE_NAME_NON_NAR: "realtors:agent_details_non_nar",
    PAGE_MODULE_WITH_AGENT: "realtors:agent_details_non_nar:with_agents",
    PAGE_MODULE_NO_AGENT: "realtors:agent_details_non_nar:no_agents",
  },
  ADP_MODAL: {
    RECOMM_MODAL_TRIGGER: "realtors:agent_details:about:make_recommendations_modal",
    RECOMM_MODAL_NAME: "realtors:recommendations_modal",
    ASK_QUESTION_MODAL_TRIGGER: "realtors:agent_details:top:ask_a_question",
    ASK_QUESTION_MODAL_NAME: "realtors:lead_modal",
    SHARE_MODAL_NAME: "realtors:agent_share_page",
    SHARE_MODAL_TRIGGER: "realtors:agent_details:contact_details:share",
    RATING_MODAL_NAME: "realtors:write_review_modal",
    RATING_MODAL_TRIGGER: "realtors:agent_details:ratings_reviews:rate_write_review",
    BANNER_FORM_MODAL_NAME: "nonNARBannerForm",
    BANNER_FORM_MODAL_TRIGGER: "realtors:agent_details:non_nar_banner:get_started",
    CONTACT_AGENT_MODAL_NAME: "nonNARContactAgentForm",
    CONTACT_LEAD_PLACEMENT: "realtors:agent_details:contact_agent:send",
    CONTACT_AGENT_MODAL_TRIGGER: "realtors:agent_details:contact_agent:send_message",
    FIND_AN_AGENT_MODAL_NAME: "nonNARFindAnAgent",
    FIND_AN_AGENT_MODAL_TRIGGER: "realtors:agent_details:persistent_footer:find_an_agent",
    V1_DESKTOP_VIEWPROFILE_MODAL_NAME: "nonNARSubmitToViewProfile",
    V1_DESKTOP_VIEWPROFILE_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:agent_recommendations:view_profile",
    V1_MOBILE_VIEWPROFILE_MODAL_NAME: "nonNARSubmitToViewProfile",
    V1_MOBILE_VIEWPROFILE_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:persistent_footer:view_profile",
    V2_DESKTOP_VIEWPROFILE_MODAL_NAME: "nonNARSubmitToViewProfile",
    V2_DESKTOP_VIEWPROFILE_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:agent_recommendations:view_profile",
    V2_MOBILE_VIEWPROFILE_MODAL_NAME: "nonNARSubmitToViewProfile",
    V2_MOBILE_VIEWPROFILE_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:find_agent_help:view_profile",
    AGENT_RECOMMENDATION_MODAL_NAME: "nonNARAgentRecommendations",
    WITHOUT_AGENT_RECOMMENDATION_MODAL_NAME: "nonNARAgentNetwork",
    AGENT_RECOMMENDATION_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:persistent_footer:find_an_agent",
    AGENT_HELP_MODAL_NAME: "nonNARAgentHelp",
    AGENT_HELP_MODAL_TRIGGER: "realtors:agent_details_non_nar",
    AGENT_HELP_RECOMMENDATION_MODAL_NAME: "nonNARAgentNetwork",
    AGENT_HELP_RECOMMENDATION_MODAL_TRIGGER:
      "realtors:agent_details_non_nar:find_agent_help:see_recommendations",
  },
  LANDING_PAGE: {
    PAGE_TYPE: "realtor:landing",
    PAGE_NAME: "realtor:landingpage",
  },
};
export const LANGUAGE = {
  ENGLISH: "EN",
  SPANISH: "es",
};
export const TRACKING_EVENTS = {
  MODAL_IMPRESSION: "modalImpression",
  CLICK: "click",
  SOCIAL_SHARE: "socialShare",
  EMAIL_SHARE: "emailShare",
  FAR_LEAD: "farLead",
  SEARCH: "search",
  REFINED_SEARCH: "refinedSearch",
  BANNER_FORM_LEAD: "farLead",
  MODULE_IMPRESSION: "moduleImpression",
};
export const OMNITURE_LINK_NAME = {
  BREADCRUMB: {
    HOME: "realtors:srp_list:breadcrumb:rdchome_link",
    LINK: "realtors:srp_list:breadcrumb:landing_link",
    SRP_CDP: "realtors:office_details:breadcrumb:srp_link",
    SRP_TDP: "realtors:team_details:breadcrumb:srp_link",
  },
  FILTER: {
    MAP: {
      SORTING: "realtors:srp_map:search_filters:sorting_activity",
      RATING: "realtors:srp_map:search_filters:rating",
      RECOMMENDATIONS: "realtors:srp_map:search_filters:recommendations",
      PRICE_RANGE: "realtors:srp_map:search_filters:price_range",
      WORKED_WITH: "realtors:srp_map:search_filters:worked_with",
      MORE_FILTER: "realtors:srp_map:search_filters:more_filters",
    },
    LIST: {
      SORTING: "realtors:srp_list:search_filters:sorting_activity",
      RATING: "realtors:srp_list:search_filters:rating",
      RECOMMENDATIONS: "realtors:srp_list:search_filters:recommendations",
      PRICE_RANGE: "realtors:srp_list:search_filters:price_range",
      WORKED_WITH: "realtors:srp_list:search_filters:worked_with",
      MORE_FILTER: "realtors:srp_list:search_filters:more_filters",
    },
    SORTING: {
      MOST_RECENT_ACTIVITY: "realtors:srp_list:sort:most_recent_activity",
      HIGHEST_RATINGS: "realtors:srp_list:sort:highest_ratings",
      MOST_RECOMMENDATIONS: "realtors:srp_list:sort:most_recommendations",
      MOST_FOR_SALE_LISTINGS: "realtors:srp_list:sort:most_for_sale_Listings",
      MOST_SOLD_LISTINGS: "realtors:srp_list:sort:most_sold_listings",
    },
  },
  PAGINATION: {
    PAGE_NUMBERS: "realtors:srp_list:pagination:page_numbers",
    PREVIOUS: "realtors:srp_list:pagination:prev_link",
    NEXT: "realtors:srp_list:pagination:next_link",
  },
  LIST: {
    AGENT: "realtors:srp_list:agent_list_card:whole_card",
    OFFICE: "realtors:srp_list:office_list_card:whole_card",
    TEAM: "realtors:srp_list:team_list_card:whole_card",
    EMAIL: "realtors:srp_list:agent_list_card:email",
  },
  SRP: {
    LANDING_DROPDOWN: "realtors:landing:advanced_search:type_dropdown",
    LANDING_SEARCH: "realtors_hp:searchBox:search",
    LANDING_CERTIFICATE:
      "realtors:landing:advanced_search:designations_certifications_add_criteria",
    FIND_A_REALTOR: "realtors:srp_list:how_to_select_realtor:find_a_realtor",
    EVERYONES_READING_1:
      "realtors:srp_list:everyones_reading:how_to_find_the_right_real_estate_agent",
    EVERYONES_READING_2:
      "realtors:srp_list:everyones_reading:first_time_home_buyer_resource_center",
    EVERYONES_READING_3: "realtors:srp_list:everyones_reading:complete_guide_to_selling_your_house",
    EVERYONES_READING_4: "realtors:srp_list:everyones_reading:estimate_your_home_value",
    EVERYONES_READING_5:
      "realtors:srp_list:everyones_reading:compare_home_loan_and_get_preapproved",
  },
  MAP: {
    AGENT: "realtors:srp_map:search_results:agent_map_card",
    OFFICE: "realtors:srp_map:search_results:office_map_card",
    TEAM: "realtors:srp_map:search_results:team_map_card",
    MARKER: "realtors:srp_map:search_results:pins_or_cluster",
    EMAIL: "realtors:srp-map:search_results:agent_map_card:contact_email",
  },
  CDP: {
    SHARE: "realtors:office_details:cover:share",
    CONTACT: "realtors:office_details:cover:contact_info",
    PHONE: "realtors:office_details:contact_info_modal:phone_number",
    VIEW_WEB: "realtors:office_details:contact_info:view_website",
    VIEW_SOCIAL: "realtors:office_details:contact_info_modal:social_media",
    FB_SHARE: "realtors:office_details:share:fb",
    TW_SHARE: "realtors:office_details:share:tw",
    EMAIL_SHARE: "realtors:office_details:share:email",
    AGENTS_NAV: "realtors:office_details:list_of_agents:agent",
    LISTING_NAV: "realtors:office_details:sub_nav:listing_activity",
    ABOUT_NAV: "realtors:office_details:sub_nav:about",
    LIST_CARD: "realtors:office_details:listing_activity:listing_card",
    LIST_CARD_MORE: "realtors:office_details:listing_activity:load_more_listings",
    AGENTS_MORE: "realtors:office_details:list_of_agents:view_more_members",
  },
  TDP: {
    SHARE: "realtors:team_details:cover:share",
    CONTACT: "realtors:team_details:cover:contact_info",
    SHARE_TOP: "realtors:team_details:top:share_page",
    ABOUT_NAV: "realtors:team_details:sub_nav:about",
    TEAM_NAV: "realtors:team_details:sub_nav:team_info",
    LISTING_NAV: "realtors:team_details:sub_nav:listing_activity",
    TEAM_MEMBER: "realtors:team_details:team_members:member",
    LISTING_NAV_All: "realtors:team_details:listing_activity:listings",
    LISTING_NAV_SALE: "realtors:team_details:listing_activity:for_sale",
    LISTING_NAV_SOLD: "realtors:team_details:listing_activity:sold",
    LISTING_NAV_OPEN: "realtors:team_details:listing_nav:open_house",
    LISTING_NAV_RENT: "realtors:team_details:listing_nav:for_rent",
    LISTING_MORE: "realtors:team_details:bottom:load_more_activity",
    LIST_CARD_MORE: "realtors:team_details:listing_activity:load_more_listings",
    LISTING_CARD: "realtors:team_details:listing_activity:listing_card",
    LIST_CARD_PIN: "realtors:team_details:pin:listing_card",
    PHONE: "realtors:team_details:contact_details:phone_number",
    VIEW_WEB: "realtors:team_details:contact_info:view_website",
    VIEW_SOCIAL: "realtors:team_details:contact_info_modal:social_media",
    FB_SHARE: "realtors:team_details:share:fb",
    TW_SHARE: "realtors:team_details:share:tw",
    EMAIL_SHARE: "realtors:team_details:share:email",
    SEND_EMAIL: "realtors:team_details:contact_details:send_email",
    AGENTS_MORE: "realtors:team_details:list_of_agents:view_more_members",
    PHONE_OFFICE: "realtors:team_details:contact_details:office",
    PHONE_HOME: "realtors:team_details:contact_details:home",
    WEB: "realtors:team_details:contact_details:website",
    CONTINUE_READING: "realtors:team_details:profile_details:continue_reading",
  },
  ADP: {
    SHARE: "realtors:agent_details:contact_details:share",
    TRAVERSE_REVIEW: "realtors:agent_details:top:reviews_traverse",
    TRAVERSE_RECOMM: "realtors:agent_details:top:recommendations_traverse",
    WRITE_REVIEW: "realtors:agent_details:ratings_reviews:rate_write_review",
    WRITE_RECOM: "realtors:agent_details:recommendations:write_recommendation",
    WRITE_FIRST_REVIEW: "realtors:agent_details:thumbnail:write_1st_review",
    WRITE_FIRST_RECOM: "realtors:agent_details:thumbnail:write_1st_recommendation",
    PHONE: "realtors:agent_details:contact_details:mobile",
    WEB: "realtors:agent_details:contact_details:website",
    BROKER_WEB: "realtors:agent_details:about:brokerage_website",
    LISTING_NAV_All: "realtors:agent_details:listing_activity:listings",
    LISTING_NAV_SALE: "realtors:agent_details:listing_activity:for_sale",
    LISTING_NAV_SOLD: "realtors:agent_details:listing_nav:recently_sold",
    LISTING_NAV_OPEN: "realtors:agent_details:listing_nav:open_house",
    LISTING_NAV_RENT: "realtors:agent_details:listing_nav:for_rent",
    LIST_CARD: "realtors:agent_details:listing_activity:listing_card",
    LIST_CARD_PIN: "realtors:agent_details:pin:listing_card",
    LISTING_MORE: "realtors:agent_details:listing_activity_card:load_more",
    LISTING_CARD_All: "realtors:agent_details:listing_activity_card:view_all",
    LISTING_CARD_SALE: "realtors:agent_details:listing_activity_card:for_sale",
    LISTING_CARD_SOLD: "realtors:agent_details:listing_activity_card:recently_sold",
    LISTING_CARD_OPEN: "realtors:agent_details:listing_activity_card:open_house",
    LISTING_CARD_RENT: "realtors:agent_details:listing_activity_card:for_rent",
    RECOMM_MODAL_SUBMIT: "realtors:agent_details:recommend_me_modal:submit",
    RATING_MODAL_SUBMIT: "realtors:agent_details:write_review_modal:submit",
    FB_SHARE: "realtors:agent_details:share:fb",
    TW_SHARE: "realtors:agent_details:share:tw",
    EMAIL_SHARE: "realtors:agent_details:share:email",
    PHONE_OFFICE: "realtors:agent_details:contact_details:office",
    PHONE_HOME: "realtors:agent_details:contact_details:home",
    CONTINUE_READING: "realtors:agent_details:profile_details:continue_reading",
    BANNER_FORM_CALL: "realtors:agent_details:non_nar_banner:call",
    BANNER_FORM_SUBMIT_CALL: "realtors:agent_details:non_nar_banner:call",
    BANNER_LEAD_SUBMIT: "realtors:agent_details_non_nar:view_agent_profile:submit",
    BANNER_LEAD_SUBMIT_MOBILE: "realtors:agent_details_non_nar:persistent_footer:submit",
    BANNER_LEAD_SUBMIT_V1_DESKTOP: "realtors:agent_details_non_nar:view_agent_profile:submit",
    BANNER_LEAD_SUBMIT_V2_DESKTOP: "realtors:agent_details_non_nar:view_agent_profile:submit",
    BANNER_LEAD_SUBMIT_V1_MOBILE: " realtors:agent_details_non_nar:persistent_footer:submit",
    BANNER_LEAD_SUBMIT_V2_MOBILE: "realtors:agent_details_non_nar:find_agent_help:submit",
  },
  HOMEPAGE: {
    WHY_REALTOR: "realtors:landing:editorial_articles:why_realtor",
    CODE_ETHICS: "realtors:landing:editorial_articles:what_code_ethics_means_to_you",
    LEARN_PROPOSALS: "realtors:landing:editorial_articles:learn_more_about_proposals",
    SHOW_MORE: "realtors:landing:select_credentials:show_more",
    CERTIFICATION_DONE:
      "realtors:landing:designations_certifications_add_criteria:select_credentials",
  },
};
